// LIBS
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FileCSV from 'src/components/FileCSV';

import { Button, Typography } from '@components';

// Actions
import { actions as modalActions } from '@store/ducks/modal';
import { actions as userActions } from '@store/ducks/user';

// Styles
import ArrowRight from '@icons/arrow-right.svg';
import { ButtonWrapper, FileInputArea, TitleModal, Wrapper } from './styles';

const ModalImportUsers = () => {
  const dispatch = useDispatch();
  const { loading, errorMessage } = useSelector((state) => state.user);
  const [csvFile, setCsvFile] = useState();
  const [fileErrorMessage, setFileErrorMessage] = useState({
    message: '',
    columns: [],
  });

  const handleChangeFileInput = (file) => {
    setFileErrorMessage({ message: '', columns: [] });
    setCsvFile(file);
  };

  const closeModal = useCallback(() => {
    dispatch(
      modalActions.close({ type: 'IMPORT_USERS', props: 'CLOSE_IMPORT_USERS' })
    );
  }, [dispatch]);

  const handleImportClick = () => {
    if (csvFile) {
      const data = new FormData();
      data.append('file', csvFile);

      dispatch(
        userActions.sendImportUsersRequest({
          data,
        })
      );
    }
  };

  return (
    <>
      <TitleModal>
        <Typography as="h1" weight="bold" size="32px" className="title">
          Importar lista de usuários
        </Typography>
      </TitleModal>
      <Wrapper>
        <p>
          Aqui você pode fazer upload do arquivo modelo em .csv com todos os
          usuários que deseja cadastrar.
        </p>

        <FileCSV
          required
          onChange={handleChangeFileInput}
          errorMessage={fileErrorMessage.message}
        >
          <FileInputArea>
            <p>Selecione ou arraste aqui a sua planilha no formato csv.</p>
          </FileInputArea>
        </FileCSV>

        <ButtonWrapper>
          <Button type="button" variant="secondary" onClick={closeModal}>
            Cancelar
          </Button>

          <Button
            type="button"
            variant="primary"
            rightIcon={<ArrowRight />}
            onClick={handleImportClick}
            disabled={!csvFile || loading}
            loading={loading}
          >
            Importar
          </Button>
        </ButtonWrapper>
      </Wrapper>
    </>
  );
};

export default ModalImportUsers;
